import React, { useState } from 'react';

import RequestService from "../../services/request.service";


import { Form, Col, Row } from 'react-bootstrap'

import { Formik } from 'formik';
import * as yup from 'yup';


import { toast } from 'react-toastify'


import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from 'date-fns/locale/es';


import moment from 'moment'


import Dialog from '../../services/Dialogs'
import { Button, Modal } from 'react-bootstrap'



import './chat.scss'

const ModalNotasTramite = ( params : any ) => {


  const dialog = new Dialog();



  const { show, handleClose, tramite } = params


    const [ mensajes, setMensajes ] = useState<any>([])
    const [ cargando_, setCargando ] = useState( true )

  const cargarNotas = async()=>{
    try{
      setCargando(true)
      let skip = 0
      let response : any = await RequestService.getEndPoint(`mensajes/${tramite.uuid_tramite}`)
      setMensajes(response.data)
      setCargando(false)
    }
    catch(e:any){
      setCargando(false)
      toast.error(e.response.data)
    }
  }



  React.useEffect(() => {
    cargarNotas()
  }, []);



const schema = yup.object().shape({
  mensaje: yup.string().required("Debes escribir algo"),
});


const enviarFormulario = async (nuevo_usuario:any,resetForm:any,) =>{
  try{
      await dialog.open({
        accept: 'Si',
        cancel: 'No',
        dialogClass: '',
        message: '¿Deseas agregar el siguiente mensaje?',
        // soundAccept: 'https://assets.stoumann.dk/audio/accept.mp3',
        // soundOpen: 'https://assets.stoumann.dk/audio/open.mp3',
        // target: event.target,
        template: `${nuevo_usuario.mensaje}`
      })
      let dialogo : any = await dialog.waitForUser()
      if(dialogo){
        setCargando(true)
      // console.log('lo que se envia es:', nuevo_usuario)
        let response = await RequestService.create(`mensaje/agregar/${tramite.uuid_tramite}`, nuevo_usuario)

        if(response){
          toast.success('Agregamos el mensaje')
          setMensajes(response.data)
          resetForm()
        }
        else{
          toast.error('Error al crear usuario en el servidor')
        }  
        
      }
    }
    catch(e:any){
      toast.error(e.response.data)
    }
     
}


  return (
    <>
      <Modal show={show} onHide={handleClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Notas del Trámite</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            // JSON.stringify(mensajes)
          }

              <h4 className="titulares">Trámite</h4>
              <p className="text-center">FOLIO <b>{tramite.folio}</b></p>



              <div className="row">
                  <div className="col-md-12">
                      <div className="panel panel-primary">
                          <div className="panel-heading mb-2">
                              <span className="fa fa-comment"></span> Chat
                          </div>
                          <div className="panel-body">
                              <ul className="chat">

                                {
                                  mensajes.map( (mensaje:any,index:number) => 


                                          <li key={index} className="left clearfix"><span className="chat-img pull-left">
                                          </span>
                                              <div className="chat-body clearfix">
                                                  <div className="header">
                                                      <strong className="primary-font">{mensaje.idusuario.nombres} {mensaje.idusuario.paterno} {mensaje.idusuario.materno}</strong> <small className="pull-right text-muted">
                                                          <span className="fa fa-clock-o"></span> {mensaje.fecha_creacion}</small>
                                                  </div>
                                                  <p>{mensaje.mensaje}</p>
                                              </div>
                                          </li>


                                   )
                                }

                              {
                                                                // <li className="left clearfix"><span className="chat-img pull-left">
                                                                // </span>
                                                                //     <div className="chat-body clearfix">
                                                                //         <div className="header">
                                                                //             <strong className="primary-font">Jack Sparrow</strong> <small className="pull-right text-muted">
                                                                //                 <span className="fa fa-clock-o"></span> 12 mins ago</small>
                                                                //         </div>
                                                                //         <p>
                                                                //             Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare
                                                                //             dolor, quis ullamcorper ligula sodales.
                                                                //         </p>
                                                                //     </div>
                                                                // </li>
                                                                // <li className="right clearfix"><span className="chat-img pull-right">
                                                                // </span>
                                                                //     <div className="chat-body clearfix">
                                                                //         <div className="header">
                                                                //             <small className=" text-muted"><span className="fa fa-clock-o"></span> 13 mins ago</small>
                                                                //             <strong className="pull-right primary-font">Bhaumik Patel</strong>
                                                                //         </div>
                                                                //         <p>
                                                                //             Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare
                                                                //             dolor, quis ullamcorper ligula sodales.
                                                                //         </p>
                                                                //     </div>
                                                                // </li>
                                                                // <li className="left clearfix"><span className="chat-img pull-left">
                                                                // </span>
                                                                //     <div className="chat-body clearfix">
                                                                //         <div className="header">
                                                                //             <strong className="primary-font">Jack Sparrow</strong> <small className="pull-right text-muted">
                                                                //                 <span className="fa fa-clock-o"></span> 14 mins ago</small>
                                                                //         </div>
                                                                //         <p>
                                                                //             Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare
                                                                //             dolor, quis ullamcorper ligula sodales.
                                                                //         </p>
                                                                //     </div>
                                                                // </li>
                                                                // <li className="right clearfix"><span className="chat-img pull-right">
                                                                // </span>
                                                                //     <div className="chat-body clearfix">
                                                                //         <div className="header">
                                                                //             <small className=" text-muted"><span className="fa fa-clock-o"></span> 15 mins ago</small>
                                                                //             <strong className="pull-right primary-font">Bhaumik Patel</strong>
                                                                //         </div>
                                                                //         <p>
                                                                //             Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare
                                                                //             dolor, quis ullamcorper ligula sodales.
                                                                //         </p>
                                                                //     </div>
                                                                // </li>
                              
                              }


                              </ul>
                          </div>
                          <div className="panel-footer">






                              <Formik validationSchema={schema} onSubmit={(values,{resetForm})=>{enviarFormulario(values, resetForm)}} initialValues={{ mensaje:  "" }} >
                                {({
                                  handleSubmit,
                                  handleChange,
                                  setFieldValue,
                                  handleBlur,
                                  values,
                                  touched,
                                  isValid,
                                  errors,
                                }) => (
                                  <Form noValidate onSubmit={handleSubmit}>

                                  
                                      <Form.Group className="mb-3" controlId="mensaje">
                                        <Form.Label>Mensaje:</Form.Label>
                                        <Form.Control
                                          type="text"
                                          as="textarea" rows={3}
                                          required
                                          name="mensaje"
                                          value={values.mensaje}
                                          onChange={(e)=>{ setFieldValue('mensaje', e.target.value.toUpperCase()) }}
                                          isInvalid={!!errors.mensaje}
                                        />
                                        <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                      </Form.Group>

                                      <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                                        <button className="btn btn-primary" type="submit">Agregar Mensaje</button>
                                      </div>

                                    

                                  </Form>
                                )}
                              </Formik>



                          </div>
                      </div>
                  </div>
              </div>



        </Modal.Body>



      </Modal>
    </>
  );
}


export default ModalNotasTramite;